import assetPath from '/app/packages/lebenslauf/articles/src/assets/lebenslauf-luecken.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')